import React from 'react';
import { Star, Sparkles, ShoppingBag } from 'lucide-react';

const Products: React.FC = () => {
  const products = [
    {
      id: 1,
      name: "Cartera Clásica",
      description: "Diseño elegante y atemporal, perfecta para cualquier ocasión",
      features: ["100% anillas recicladas", "Hecha a mano", "Diseño único"]
    },
    {
      id: 2,
      name: "Cartera Casual",
      description: "Estilo relajado para el día a día con un toque sostenible",
      features: ["Material resistente", "Colores naturales", "Fácil de llevar"]
    },
    {
      id: 3,
      name: "Cartera de Noche",
      description: "Sofisticada y compacta, ideal para eventos especiales",
      features: ["Acabado brillante", "Tamaño perfecto", "Elegante y práctica"]
    }
  ];

  return (
    <section className="products-section">
      <div className="container">
        <h2 className="section-title">Nuestra Colección</h2>
        <p className="section-subtitle">
          Cada cartera es única, hecha con dedicación, amor, estilo y compromiso
        </p>

        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <div className="image-placeholder">
                  <ShoppingBag size={48} />
                  <p>Imagen de {product.name}</p>
                </div>
                <div className="exclusive-badge">
                  <Sparkles size={16} />
                  <span>Exclusiva</span>
                </div>
              </div>

              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>

                <div className="product-features">
                  {product.features.map((feature, index) => (
                    <div key={index} className="feature">
                      <Star size={14} />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="product-actions">
                  <button className="btn-interest">Me Interesa</button>
                  <button className="btn-more">Más Info</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="availability-note">
          <p>
            <strong>Nota:</strong> Como cada cartera es hecha a mano, la disponibilidad
            es limitada. Cada pieza lleva tiempo y dedicación en su creación.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Products;